import { render, staticRenderFns } from "./TrialOverlay.vue?vue&type=template&id=0ac66e9a"
import script from "./TrialOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrialOverlay.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports